<!-- 地址管理 地址查询 -->
<template>
<div class="page-form">
    <PageBack :title="title" />
    <div class="detail-wrap">
        <el-button type="primary" @click="handleAdd" style="margin: 20px 0;">新增地址</el-button>
        <el-table border :data="tableData" style="width: 100%;">
            <el-table-column  prop="index"   label="序号"   width="50" align="center"/>     
            <el-table-column  prop="name"  label="姓名" width="120"  align="center"/>  
            <el-table-column  prop="phone"  label="联系电话" width="120"  align="center"/>
            <el-table-column  prop="province"   label="省" width="140" align="center"/>              
            <el-table-column  prop="city"   label="市" width="100" align="center"/>
            <el-table-column  prop="district"   label="县（区" width="140" align="center"/> 
            <el-table-column  prop="addressDetail"   label="详细地址" width="250" align="center"/> 
            <el-table-column  prop=""   label="是否默认" width="120" align="center">
                <template slot-scope="scope">
                    <el-tag type="danger" v-if="scope.row.isDefault ==='0'"> 
                        {{ scope.row.isDefault ==='0'? '默认': '' }} </el-tag>                   
                </template>
            </el-table-column> 
            <el-table-column  fixed="right" label="操作">
                <template slot-scope="scope">   
                    <el-button @click="handleEdit(scope.row)" type="text" 
                    size="small" >编辑</el-button>   
                    <el-button @click="handleDelete(scope.row)" type="text" 
                    size="small" >删除</el-button>   
                </template>
            </el-table-column>
        </el-table>
    </div>
    <add-address  
        :title="titleAddress"  
        :formData="formData"    
        v-if="isShowAddress"
        @close="closeDialog"
        @confirm="handleConfirmAddress"/>
</div>
</template>

<script>
import PageBack from '@/components/PageHeader'
import pagination  from '@/components/Pagination'
import AddAddress from '../product/components/addAddress'
export default {
    components: {
        PageBack,
        pagination,
        AddAddress
    },
    data() {
        return {
            tableData: [],
            isShowAddress: false,
            titleAddress: '',
            formData: {}
        }
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
        roles(){
            return localStorage.getItem('roles')
        }, 
        adminRoles(){
            let value = localStorage.getItem('roles')
            if(value === '管理员'){
                return true
            }else{
                return false
            }            
        }, 
    },
    created() {

    },
    mounted() {
        this.initData()
    },
    methods: {
        initData(){
            let params = {
                opcode: this.$code.AddressQuery,
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let arr= res.Data.DataTable
                    if(arr.length > 0){                    
                        let addressArr = arr.map((item,index)=>{
                            return{
                                index: index+1,
                                district: item['县（区）'],
                                city: item['市'],
                                province: item['省'],
                                phone: item['收货人电话'],
                                name: item['收货人'],
                                addressDetail: item['详细地址'],
                                isDefault: item['是否默认地址'],
                                id: item['地址序号']
                            }
                        })
                        this.tableData = addressArr
                    }else{
                        this.tableData = []
                    }
                }
            })
        },
        handleAdd(){
            this.isShowAddress = true
            this.titleAddress = '新增地址'
        },
        handleConfirmAddress(){
            this.initData()
            this.closeDialog()
        },
        handleEdit(row){
            this.isShowAddress = true
            this.titleAddress = '编辑地址'
            this.formData = {...row}
        },
        handleDelete(row){
            this.$confirm('删除后将影响发货！','确认删除吗？',).then(res=>{
                this.confirmDelete(row)
            }).catch(err=>{
                console.log(err)
            })
        },
        confirmDelete(row){
            let params = {
                opcode: this.$code.RemoveAddress,
                i_serial: row.id
            }
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    this.$message.success('删除成功')
                    this.initData()
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        closeDialog(){
            this.isShowAddress = false
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/admin/addressQuery.vue